import WUGUOCHENG from "@/assets/img/teacher/wuguocheng.png";
import GAOYUNPENG from "@/assets/img/teacher/gaoyunpeng.png";
import LIXIUZHEN from "@/assets/img/teacher/lixiuzhen.png";
import HUHAIBO from "@/assets/img/teacher/huhaibo.png";
import CAOXUE from "@/assets/img/teacher/caoxue.png";
// import CHENLEI from "@/assets/img/teacher/chenlei.png";
import BIXIMING from "@/assets/img/teacher/biximing.png";
import JIANGCHANGQING from "@/assets/img/teacher/jiangchangqing.png";
import SHIJIE from "@/assets/img/teacher/shijie.png";

// import notice1 from "@/assets/img/中国心理卫生协会官网通知.png";
// import notice2 from "@/assets/img/合作机构管理细则.jpg";
// import notice3 from "@/assets/img/24年12月家庭教育考试通知.png";
// import notice4 from "@/assets/img/假证！虚假宣传.jpg";
// import notice5 from "@/assets/img/心理咨询师考试安排.png";

import CHANGQING from "@/assets/img/家庭教师/姜长青.png";
import YUEXIAODONG from "@/assets/img/家庭教师/岳晓东.png";
import ZHANGHONGYUU from "@/assets/img/家庭教师/张宏宇.png";
import LIUMINGXIN from "@/assets/img/家庭教师/柳铭心.png";
import LIYONG from "@/assets/img/家庭教师/李勇.png";
import HOURUIHE from "@/assets/img/家庭教师/侯瑞鹤.png";
import XUJUN from "@/assets/img/家庭教师/徐军.png";
import SHAOCHANGQING from "@/assets/img/家庭教师/邵长青.png";
import ZHANGYAMING from "@/assets/img/家庭教师/张雅明.png";
import PENGYUZHEN from "@/assets/img/家庭教师/彭玉珍.png";
import QIANGGUANGFENG from "@/assets/img/家庭教师/强光峰.png";

// import COURSEIMG1 from "@/assets/img/courseImg/抑郁专题商品图.jpg";
// import COURSEIMG2 from "@/assets/img/courseImg/婴幼儿身心发展商品图.jpg";
// import COURSEIMG3 from "@/assets/img/courseImg/家庭心理辅导技能商品图.jpg";
// import COURSEIMG4 from "@/assets/img/courseImg/儿童行为习惯与思维习惯培养商品图.jpg";
// import COURSEIMG5 from "@/assets/img/courseImg/儿童学习能力培养商品图.jpg";
// import COURSEIMG6 from "@/assets/img/courseImg/小学儿童身心发展及教育方式.jpg";
// import COURSEIMG7 from "@/assets/img/courseImg/青春期身心发展及教育方式商品图.jpg";
// import COURSEIMG8 from "@/assets/img/courseImg/青春期人格品质的塑造商品图.jpg";
// import COURSEIMG9 from "@/assets/img/courseImg/亲自陪伴实操技能商品图.jpg";
// import COURSEIMG10 from "@/assets/img/courseImg/良好亲子沟通实操技能商品图.jpg";
// import COURSEIMG11 from "@/assets/img/courseImg/家庭教育工作者的“法宝”商品图.jpg";
// import COURSEIMG12 from "@/assets/img/courseImg/家庭教育工作方法商品图.jpg";
// import COURSEIMG13 from "@/assets/img/courseImg/父母教养方式对孩子的影响商品图.jpg";
// import COURSEIMG14 from "@/assets/img/courseImg/提高家庭教育指导的时效性商品图.jpg";
// import COURSEIMG15 from "@/assets/img/courseImg/儿童的社会性商品图.jpg";
// import COURSEIMG16 from "@/assets/img/courseImg/儿童六大商品图.jpg";
// import COURSEIMG17 from "@/assets/img/courseImg/儿童青少年常见心理问题的识别.jpg";
// import COURSEIMG18 from "@/assets/img/courseImg/心理评估课程图.jpg";
// import COURSEIMG19 from "@/assets/img/courseImg/专业伦理与案例督导.jpg";

export const psyTeacher = [
  // {
  //   name_zh: "武国城",
  //   name_cn: "WUGUOCHENG",
  //   pic: WUGUOCHENG,
  //   titles: [
  //     "中国心理卫生协会名誉理事长",
  //     "中国心理学会心理咨询师<br />工作委员会副主任委员",
  //     "空军军医大学教授",
  //     "空军特色医学中心研究员",
  //   ],
  // },
  {
    name_zh: "高云鹏",
    name_cn: "GAOYUNPENG",
    pic: GAOYUNPENG,
    titles: [
      "著名心理学家",
      "北京大学心理系教授",
      "北京大学心理培训中心主任",
      "心理咨询师国家职业<br />资格培训教程编委",
      "",
    ],
  },
  {
    name_zh: "李秀珍",
    name_cn: "LIXIUZHEN",
    pic: LIXIUZHEN,
    titles: [
      "全国健康心理专业委员会专家",
      "全国心理咨询与治疗<br/>专业委员会委员",
      "全军临床心理专业委员会常委",
      "北京军区医学心理专业<br>委员会主任委员",
    ],
  },
  // {
  //   name_zh: "曹雪",
  //   name_cn: "CAOXUE",
  //   pic: CAOXUE,
  //   titles: [
  //     "毕业于中国人民大学哲学系",
  //     "心理咨询师协会（CAPA）<br/>筹委会工作委员会委员",
  //     "国家二级心理咨询师<br/>系统式治疗取向心理咨询师",
  //     "国家心理咨询师培训教师",
  //   ],
  // },
  {
    name_zh: "姜长青",
    name_cn: "JIANGCHANGQING",
    pic: JIANGCHANGQING,
    titles: [
      "毕业于北京师范大学心理系",
      "心理咨询专业委员会委员",
      "国家心理咨询师职业培训专家",
      "心理卫生专业委员会委员",
    ],
  },
  {
    name_zh: "史杰",
    name_cn: "SHIJIE",
    pic: SHIJIE,
    titles: [
      "主任医师",
      "教授，研究生导师",
      "中国心理卫生协心理咨询师<br/>专业委员会副主任委员、督导师",
    ],
  },
  // {
  //   name_zh: "胡海波",
  //   name_cn: "HUHAIBO",
  //   pic: HUHAIBO,
  //   titles: [
  //     "国家心理咨询师专家组成员",
  //     "中国心理卫生协会会员",
  //     "北京心理卫生协会<br />社区心理工作专业委员会委员",
  //     "IHNMA/WMECC催眠保健治疗",
  //   ],
  // },
  {
    name_zh: "毕希名",
    name_cn: "BIXIMING",
    pic: BIXIMING,
    titles: [
      "心理咨询师",
      "国家心理咨询师培训教材编委",
      "青岛大学医学院教授",
      "研究生导师",
      "著名心理学家",
    ],
  },
];
export const teachersList = [
  // {
  //   name_zh: "武国城",
  //   name_cn: "WUGUOCHENG",
  //   pic: WUGUOCHENG,
  //   titles: [
  //     "中国心理卫生协会名誉理事长",
  //     "中国心理学会心理咨询师<br />工作委员会副主任委员",
  //     "空军军医大学教授",
  //     "空军特色医学中心研究员",
  //   ],
  // },
  {
    name_zh: "高云鹏",
    name_cn: "GAOYUNPENG",
    pic: GAOYUNPENG,
    titles: [
      "著名心理学家",
      "北京大学心理系教授",
      "北京大学心理培训中心主任",
      "心理咨询师国家职业<br />资格培训教程编委",
      "",
    ],
  },
  {
    name_zh: "李秀珍",
    name_cn: "LIXIUZHEN",
    pic: LIXIUZHEN,
    titles: [
      "全国健康心理专业委员会专家",
      "全国心理咨询与治疗<br/>专业委员会委员",
      "全军临床心理专业委员会常委",
      "北京军区医学心理专业<br>委员会主任委员",
    ],
  },
  // {
  //   name_zh: "曹雪",
  //   name_cn: "CAOXUE",
  //   pic: CAOXUE,
  //   titles: [
  //     "毕业于中国人民大学哲学系",
  //     "心理咨询师协会（CAPA）<br/>筹委会工作委员会委员",
  //     "国家二级心理咨询师<br/>系统式治疗取向心理咨询师",
  //     "国家心理咨询师培训教师",
  //   ],
  // },
  {
    name_zh: "姜长青",
    name_cn: "JIANGCHANGQING",
    pic: JIANGCHANGQING,
    titles: [
      "毕业于北京师范大学心理系",
      "心理咨询专业委员会委员",
      "国家心理咨询师职业培训专家",
      "心理卫生专业委员会委员",
    ],
  },
  {
    name_zh: "史杰",
    name_cn: "SHIJIE",
    pic: SHIJIE,
    titles: [
      "主任医师",
      "教授，研究生导师",
      "中国心理卫生协心理咨询师<br/>专业委员会副主任委员、督导师",
    ],
  },
  {
    name_zh: "徐军",
    name_cn: "XUJUN",
    pic: XUJUN,
    titles: [
      "国家二级心理咨询师",
      "湖南省家庭教育研究会理事",
      "中国心理卫生协会<br />注册心理咨询师",
      "国家婚姻家庭咨询师<br />职业资格考评员",
    ],
  },
  {
    name_zh: "岳晓东",
    name_cn: "YUEXIAODONG",
    pic: YUEXIAODONG,
    titles: [
      "中国著名心理学家",
      "哈佛大学心理学博士",
      "中国儿童中心副研究员",
      "香港城市大学教授",
      "首都师范大学特聘教授",
      "香港心理学会<br />辅导分会首任会长",
    ],
  },
];

export const homeTeacher = [
  {
    name_zh: "姜长青",
    name_cn: "JIANGCHANGQING",
    pic: CHANGQING,
    titles: [
      "毕业于北京师范大学心理系",
      "心理咨询专业委员会委员",
      "国家心理咨询师职业培训专家",
      "心理卫生专业委员会委员",
      "擅长压力与健康、人际关系、<br/>婚姻家庭等方面培训",
    ],
  },
  {
    name_zh: "岳晓东",
    name_cn: "YUEXIAODONG",
    pic: YUEXIAODONG,
    titles: [
      "中国著名心理学家",
      "哈佛大学心理学博士",
      "中国儿童中心副研究员",
      "香港心理学会辅导分会首任会长",
      "香港城市大学教授",
      "首都师范大学特聘教授",
    ],
  },
  {
    name_zh: "张宏宇",
    name_cn: "ZHANGHONGYUU",
    pic: ZHANGHONGYUU,
    titles: [
      "北师大心理学博士、副教授",
      "心理动力学取向心理咨询师",
      "军委科技进步二等奖",
      "北京市教育教学成果一等奖",
      "心理咨询个案5000+小时",
    ],
  },
  {
    name_zh: "柳铭心",
    name_cn: "LIUMINGXIN",
    pic: LIUMINGXIN,
    titles: [
      "中国儿童中心副研究员",
      "发展与教育心理学博士",
      "心理健康重点实验室博士后",
      "国家二级心理咨询师",
    ],
  },
  {
    name_zh: "李勇",
    name_cn: "LIYONG",
    pic: LIYONG,
    titles: [
      "心理学硕士",
      "国际教育学博士",
      "中国心理卫生协会注册心理咨询师",
      "中国心理学会心理服务委员会委员",
    ],
  },
  {
    name_zh: "侯瑞鹤",
    name_cn: "HOURUIHE",
    pic: HOURUIHE,
    titles: [
      "中国人民大学心理咨询中心副教授",
      "发展与教育心理学博士",
      "中国心理学会注册心理师",
      "第二届萨提亚家庭治疗受训导师",
    ],
  },
  {
    name_zh: "徐军",
    name_cn: "XUJUN",
    pic: XUJUN,
    titles: [
      "中国心理卫生协会注册心理咨询师",
      "国家二级心理咨询师",
      "湖南省家庭教育研究会理事",
      "国家婚姻家庭咨询师<br/>职业资格考评员",
    ],
  },
  {
    name_zh: "邵长青",
    name_cn: "SHAOCHANGQING",
    pic: SHAOCHANGQING,
    titles: [
      "国家二级心理咨询师",
      "国家基础教育实验中心与<br/>家庭教育研究所特聘专家",
      "10000+小时个案咨询<br/>和团体督导经验",
    ],
  },
  {
    name_zh: "张雅明",
    name_cn: "ZHANGYAMING",
    pic: ZHANGYAMING,
    titles: [
      "《中小学心理健康》丛书主编",
      "中科院心理所博士，教授",
      "资深心理咨询专家",
      "心理咨询咨询督导",
    ],
  },
  {
    name_zh: "彭玉珍",
    name_cn: "PENGYUZHEN",
    pic: PENGYUZHEN,
    titles: [
      "国家二级心理咨询师",
      "婚姻家庭咨询师",
      "湖南省健康管理学会理事",
      "湖南省心理健康教育与<br/>咨询专委会副主任",
    ],
  },
  {
    name_zh: "强光峰",
    name_cn: "QIANGGUANGFENG",
    pic: QIANGGUANGFENG,
    titles: [
      "中国教育学会培训部主任",
      "原山东省泰安市教育局副局长",
      "正高级教师,特级教师",
      "曲阜师范大学教授",
    ],
  },
];

// export const noticeList = [
//   {
//     title: "中国心理卫生协会官网通知",
//     date: "2023-09-13",
//     pic: notice1,
//   },
//   {
//     title: "合作机构管理细则",
//     date: "2023-09-13",
//     pic: notice2,
//   },
//   {
//     title: "24年12月家庭教育考试通知",
//     date: "2024-11-01",
//     pic: notice3,
//   },
//   {
//     title: "假证！虚假宣传... ...",
//     date: "2023-09-13",
//     pic: notice4,
//   },
//   {
//     title: "心理咨询师考试安排",
//     date: "2024-10-08",
//     pic: notice5,
//   },
// ];

export const qaList = [
  {
    title: "1．本项目设立的初衷是什么？",
    desc: "国家取消心理咨询师职业资格认证后，社会各界学习心理健康知识和心理咨询技能的热情依然很高。广大心理培训机构和心理学爱好者希望有一种心理咨询师考证培训的替代产品，继续承担起普及心理健康知识，培养心理服务人才的任务。在此背景下，中国心理卫生协会在人社部国家心理咨询师专家委员会专家的指导下，组织协会内外专家开发了“心理咨询师专业技能培训项目”， 继续满足社会各界学习心理健康知识和心理咨询技能的入门需要。",
  },
  {
    title: "2. 中国心理卫生协会的优势是什么？",
    desc: "中国心理卫生协会于1985年3月经国家经济体制改革委员会批准成立，是由我国心理健康、医疗卫生、教育、社会工作等专业领域科学工作者和有关单位自愿结成的全国性、行业性社会团体，是非营利性社会组织，为中国科学技术协会的团体会员单位。<br>协会每年都组织学术活动，办继续教育培训班、研讨班并利用电视、报纸、广播等形式开展科普活动，定期举办国际学术会议，亦在公众遭遇重大突发事件等特殊时期恪尽职守，做好本分，为推动我国心理卫生事业的发展作出大量积极努力。2008年9月，中国心理卫生协会被上级主管单位中国科协授予“抗震救灾先进集体”称号。",
  },
  {
    title: "3. 该项目是心理咨询师认证吗？",
    desc: "不是认证，取得的证书也不是职业资格证书。这是一个心理咨询师专业技能的培训项目。颁发的培训合格证书可以作为持证者受过心理学知识和心理咨询技能培训的有效证明，也可以作为持证者开展心理服务的资格参考。",
  },
  {
    title: "4. 培训合格者相当于原人社部心理咨询师认证的哪个级别？",
    desc: "本项目合格者颁发的是培训合格证书，课程设计参考了《国家心理咨询师职业标准》，内容比原来的考证培训更丰富，更有针对性和实用性。课程包含原来三级教材的内容，并新增部分内容。培训合格者相当于原来国考认证的3级+的水平。",
  },
  {
    title: "5. 已经取得人社部证书的心理咨询师还需要学习本课程么？",
    desc: "已经取得国家心理咨询师证书者不是本项目的目标人群。",
  },
  {
    title: "6. 参加基础培训取得合格证书后能从事心理咨询工作吗？",
    desc: "心理咨询现在是非准入行业，国家并没有明确具备什么样的资格才能从事心理咨询工作。不过心理咨询是一种专业性非常强的工作，从业者须恪守职业伦理，有扎实的心理学及相关学科的理论基础，接受过系统的咨询方法和技能训练，最好在专业督导的支持下，经过长时间的个人体验和个案积累，才能独立从事专业的心理咨询工作。参加基础培训取得合格证书者，还不具备独立执业心理咨询的能力，但可以从事一些基础的心理服务工作或在专业咨询师和督导的指导下做一些心理咨询的辅助工作。",
  },
  {
    title: "7. 想继续专业成长和从业的学员还要参加哪些培训？",
    desc: "学员在取得本项目培训合格证书后，如果想继续专业成长并从业，可以参加一些心理咨询基本功训练课程，咨询方法和技术的专项课程，以及面向专业服务的实战训练。如果具备条件，建议学员寻求通过咨询心理学的学历教育和准学历教育来提高素质，实现专业和职业成长。",
  },

  {
    title: "8. 培训用什么教材？",
    desc: "本项目的培训教材以《国家心理咨询师职业资格培训教程》 (2012 版)为蓝本，吸收各方面的意见，编辑而成。",
  },
  {
    title: "9. 项目对接培训机构可以宣传本培训是中国心理卫生协会组织的吗？",
    desc: "不可以。项目为中国心理卫生协会组织专家策划，但招生和培训由合作机构自己组织。培训机构按照项目所设定的培训课时和培训内容来组织有质量的培训，并代学员报名参加中心协项目部组织的考试，协会对考试合格者颁发培训合格证书。 学员和培训机构发生经济和法律关系，和中国心理卫生协会没有直接联系。协会为取证者提供证书查询服务和力所能及的执业支持服务，取证者未来也可以优先参与协会组织的各类培训。",
  },
  {
    title: "10. 培训方式和培训课时有统一要求吗？",
    desc: "培训方式：线上网络课程。项目要求 162培训课时，可以多，不能少。培训机构可以根据自己的优势和学员的要求安排一些补充课程。完成项目安排的162课时学习，是学员可以参加项目综合考试的必要条件。",
  },
  {
    title: "11. 学员报名参加培训有学历要求吗？",
    desc: "心理咨询师专业技能培训是普及性培训和入门性培训，目的在于普及心理学和心理健康知识。从其定位来讲，凡是有意愿学习了解相关知识和技能的人都可以学习。但是，对有志于从事心理咨询相关工作和职业发展的人员而言，还需要参加后续的进阶培训和专项技能培训，必须有学历门槛。按照现有的《心理咨询师国家职业标准》，三级心理咨询师的报名条件是:具有心理学、教育学、医学专业的大专以上学历，或是具有其他专业本科以上学历。 但如果学员想参加一些专项技能培训并被政府主管部门和行业协会认可从业资格，应具备最低的学历要求。就现阶段的国家标准来说，就是必须具备心理学、教育学、医学专业的大专以上学历或是其他专业本科以上学历。",
  },
  {
    title: "12. 考试方式和证书？",
    desc: "统一组织综合考试，培训机构协助实施。初定每年进行3次考试，分别在每年3，7，12月进行。考试时间120分钟。综合考试采取百分制，成绩60分及以上为及格。考试通过者，获得《心理咨询师专业技能培训证书》。证书由中国心理卫生协会统一签发。",
  },
  {
    title: "13. 考试报名是什么时候，需要提交什么样的材料？",
    desc: "考试由培训机构代学员集体报名。培训机构须为每位考生提交完整的 《心理咨询师专业技能培训综合考试报名表》和考试报名资料。",
  },
  {
    title: "14. 考场安排在哪里？",
    desc: "综合考试统一采用线上考试。",
  },
];
